import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGameStore } from '../stores/gameStore';
import { useSocket } from '../context/SocketContext';
import { gameService } from '../services/gameService';
import { GAME_STATES } from '../utils/constants';
import CurrentQuestion from '../components/CurrentQuestion';
import Countdown from '../components/Countdown';
import { RoundResults } from '../components/RoundResults';
import { useTranslation } from 'react-i18next';

const Game = () => {
	// GLobal state
	const contextGameId = useGameStore((state) => state.gameId);
	const countdown = useGameStore((state) => state.countdown);
	const gameState = useGameStore((state) => state.gameState);
	const roundResults = useGameStore((state) => state.roundResults);
	const playerId = useGameStore((state) => state.playerId);
	const host = useGameStore((state) => state.host);

	const { i18n } = useTranslation();

	const { gameId } = useParams();
	const navigate = useNavigate();
	const { socket, connected } = useSocket();

	const hostId = host?.id || null;
	const isHost = socket ? playerId === hostId : null;

	// Redirect if there's no active game or if the ID doesn't match
	useEffect(() => {
		if (!contextGameId || contextGameId !== gameId) {
			navigate('/');
		}
	}, [contextGameId, gameId, navigate]);

	// Handle answer selection
	const handleSelectAnswer = (answer) => {
		gameService.submitAnswer(socket, connected, { answer, lang: i18n.language, gameId: contextGameId, playerId });
	};

	const handleNextQuestion = () => {
		gameService.nextQuestion(socket, connected, { playerId, gameId: contextGameId });
	};

	const handleViewResults = () => {
		gameService.viewResults(socket, connected, { playerId, gameId: contextGameId });
	};

	// Render Countdown component during countdown phases
	if (countdown !== null) {
		return <Countdown />;
	}

	// Render round results
	if (gameState === GAME_STATES.ROUND_END && roundResults) {
		return (
			<RoundResults
				isHost={isHost}
				roundResults={roundResults}
				handleNextQuestion={handleNextQuestion}
				handleViewResults={handleViewResults}
			/>
		);
	}

	// Render current question
	return <CurrentQuestion onSelectAnswer={handleSelectAnswer} />;
};

export default Game;
